<div *ngIf="CitaConfirmada; then confirmacion; else pedircita"></div>

<!-- CONFIRMACIÓN DE LA CITA -->
<ng-template #confirmacion>
  <div class="capa-home confirmacion-cita">
    <h1 class="titulo">Solicitud realizada</h1>

    <div class="wrapper-confirm-img">
      <p>
        Su reserva ha sido realizada con éxito, se le ha asignado el nº de
        ticket <b>{{ oDetalleCita.ticket }}</b
        >.
      </p>
    </div>
    <div class="wrapper-confirm-img">
      <p>
        Recibirá en unos instantes la confirmación de la cita a través de un
        correo electrónico.
      </p>
    </div>

    <div class="wrapper-confirm-img">
      <img class="img-confirm-cita" src="assets/images/dibujo_cita_ok.svg" />
    </div>

    <div class="btn-grupo">
      <div title="Add to Calendar" class="addeventatc">
        Añadir al calendario
        <span class="start">{{ oCitaCalendario.FECHA_INICIO }}</span>
        <span class="end">{{ oCitaCalendario.FECHA_FIN }}</span>
        <span class="timezone">{{ oCitaCalendario.TIMEZONE }}</span>
        <span class="title">{{ oCitaCalendario.TITULO }}</span>
        <span class="description">{{ oCitaCalendario.DESCRIPCION }}</span>
        <span class="location">{{ oCitaCalendario.direccion }}</span>
      </div>
    </div>
    <div class="btn-grupo">
      <button class="btn-general" (click)="ImprimirCita()">
        <span>Imprimir</span>
      </button>

      <button class="btn-general" [routerLink]="['/']">
        <span>Continuar</span>
      </button>

      <!-- <button class="btn" (click)="NuevaCita()">Nueva cita</button> -->
    </div>
  </div>
</ng-template>

<!-- SOLICITUD DE LA CITA -->
<ng-template #pedircita>
  <div class="capa-home">
    <h1 class="titulo">Solicitar cita</h1>

    <!-- <mat-horizontal-stepper labelPosition="bottom" #stepper linear> -->

    <mat-vertical-stepper
      #stepper
      (selectionChange)="onStepChange($event)"
      linear
    >
      <mat-step [stepControl]="formArea" [editable]="isEditable">
        <ng-template matStepLabel>Área de atención</ng-template>
        <form #formArea="ngForm" (ngSubmit)="onSubmitAreaAtencion()">
          <select
            name="cmbArea"
            #cmbArea
            (change)="changeArea(cmbArea.selectedIndex)"
            required
          >
            <option
              *ngFor="let area of aDtosAreas"
              [value]="area.id_area"
              [selected]="area.id_area === citatemporal.id_area"
            >
              {{ area.DEPARTAMENTO }} >> {{ area.AREA }}
            </option>
          </select>
          <div class="mensaje tiempo">
            <p>{{ sInfoAreaCarencia }}</p>
            <p [innerHTML]="sInfoArea"></p>
          </div>

          <div class="capapersonalcita" *ngIf="AreaCitaPersonalizada()">
            <label>Indique que persona quiere que le atienda</label>
            <select
              name="cmbPersonaArea"
              #cmbPersonaArea
              (change)="changePersonaArea(cmbPersonaArea.selectedIndex)"
            >
              <option>- Cualquiera -</option>
              <option *ngFor="let aPersona of aPersonaArea" [value]="aPersona">
                {{ aPersona.PERSONA }}
              </option>
            </select>
          </div>

          <div class="capatramitecita">
            <label>Trámite que desea realizar</label>
            <select
              name="cmbTramite"
              #cmbTramite
              (change)="changeTramite(cmbTramite.selectedIndex)"
              required
            >
              <option
                *ngFor="let tramite of aTramitesArea"
                [value]="tramite"
                [selected]="tramite.id_tramite === citatemporal.id_tramite"
              >
                {{ tramite.TRAMITE }}
              </option>
            </select>
            <div *ngIf="oTramiteActivo != null" class="mensaje">
              <p
                *ngIf="oTramiteActivo.INFO_TRAMITE !== ''"
                [innerHTML]="oTramiteActivo.INFO_TRAMITE"
              ></p>
              <p>Documentación que debe aportar:</p>
              <ul>
                <li *ngFor="let documento of oTramiteActivo.DOCUMENTOS">
                  {{ documento.INFO() }}
                </li>
              </ul>
            </div>
          </div>

          <mat-slide-toggle
            color="accent"
            name="videollamada"
            [(ngModel)]="videollamada"
            *ngIf="videollamadaClienteEnabled && oAreaActiva?.videollamada"
          >
            Deseo realizar esta cita por videollamada
          </mat-slide-toggle>

          <div class="btn-grupo">
            <button
              class="btn-general center"
              *ngIf="AreaTramiteSeleccionado()"
              matStepperNext
            >
              <span>Continuar</span>
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="frmFechaCita" [editable]="isEditable">
        <ng-template matStepLabel>Fecha de la cita</ng-template>
        <form #frmFechaCita="ngForm">
          <div *ngIf="HayCitasLibresArea; then haycitas; else nohaycitas"></div>
          <ng-template #haycitas>
            <div class="calendario">
              <!-- Selector de mes/año -->
              <div>
                <select
                  name="cmbAAAAMMCita"
                  [(ngModel)]="iIndiceAnnioMesActivo"
                  #cmbAAAAMMCita
                  (change)="changeAAAAMMCita(cmbAAAAMMCita.selectedIndex)"
                  required
                >
                  <option *ngFor="let am of aAnnioMesCita; let i = index" [value]="i">
                    {{ Mes(am.MES) }} - {{ am.ANNIO }}
                  </option>
                </select>
              </div>

              <!-- Cabecera de días de la semana -->
              <div *ngFor="let diasemana of DiasSemana()">
                <div class="cajita-dia">
                  <span>{{ diasemana.substring(0, 3) }}</span>
                </div>
              </div>

              <div class="clearfloat"></div>

              <!-- Calendario: semanas y días -->
              <div *ngFor="let aSemana of aCalendario">
                <div class="cajita-dia" *ngFor="let sDia of aSemana">
                  <!-- Día no válido -->
                  <span
                    [ngClass]="
                      DiaCitaToday(sDia)
                        ? 'dia-no-libre dia-today'
                        : 'dia-no-libre'
                    "
                    *ngIf="!EsDiaFuturoValido(sDia)"
                    >{{ sDia }}</span
                  >

                  <!-- Día con horarios disponibles -->
                  <span
                    [ngClass]="
                      DiaCitaToday(sDia)
                        ? 'dia-libre-circulo-activo dia-today'
                        : 'dia-libre-circulo-activo'
                    "
                    *ngIf="DiaCitaValido(sDia) === 1"
                    (click)="changeDiaCita(sDia)"
                  >
                    {{ sDia }}
                  </span>

                  <!-- Día parcialmente disponible -->
                  <span
                    [ngClass]="
                      DiaCitaToday(sDia)
                        ? 'dia-libre-circulo dia-today'
                        : 'dia-libre-circulo'
                    "
                    *ngIf="
                      sDia !== '' &&
                      EsDiaFuturoValido(sDia) &&
                      DiaCitaValido(sDia) !== 1
                    "
                    (click)="changeDiaCita(sDia)"
                  >
                    {{ sDia }}
                  </span>
                </div>
                <div class="clearfloat"></div>
              </div>

              <div class="clearfloat"></div>
            </div>

            <!-- Mensaje de error si no se seleccionó día -->
            <p
              style="
                text-align: center;
                font-size: 1em;
                margin-bottom: 10px;
                color: #d33;
              "
              *ngIf="iDiaActivoCalendario === 0"
              class="msgerror"
            >
              Seleccione la fecha y hora de la cita
            </p>

            <!-- HORARIOS DISPONIBLES AL SELECCIONAR DÍA -->
            <div class="botones-horario" *ngIf="oFechaCitaAreaActiva != null">
              <p class="texto-horario">
                Horarios disponibles para el día seleccionado:
              </p>

              <div
                class="hora"
                *ngFor="
                  let oHHMM of oFechaCitaAreaActiva.HHMMLIBRES;
                  let i = index
                "
                [ngClass]="i === iIndiceHorarioActivo ? 'hora-activa' : 'hora'"
                (click)="changeHorario(i)"
              >
                <span>
                  {{
                    oHHMM.HH.toString().padStart(2, "0") +
                      ":" +
                      oHHMM.MM.toString().padStart(2, "0")
                  }}
                </span>
              </div>

              <!-- Botón eliminado: ya no se buscan las siguientes 5 horas -->
              <!--
              <div class="btn-grupo">
                <button class="btn-general" (click)="CargarFechasLibresArea(false);">
                  <span>No me interesa, deseo obtener las 5 siguientes horas libres</span>
                </button>
              </div>
              -->
            </div>

            <div class="btn-grupo">
              <button
                class="btn cancelar"
                matStepperPrevious
                (click)="stepperActivarEdicionArea(true); stepperMover(0)"
              >
                Retroceder
              </button>
              <button
                class="btn-general"
                (click)="BloquearPrecita()"
                *ngIf="iDiaActivoCalendario > 0"
              >
                <span>Continuar</span>
              </button>
            </div>
          </ng-template>

          <ng-template #nohaycitas>
            <div class="area_sin_citas">
              No hay citas libres para el área de atención o persona
              seleccionada
            </div>
            <button
              class="btn cancelar center"
              matStepperPrevious
              (click)="stepperActivarEdicionArea(true); stepperMover(0)"
            >
              Retroceder
            </button>
          </ng-template>
        </form>
      </mat-step>

      <mat-step [stepControl]="frmSolicitante">
        <div class="resumen-cita-modal" *ngIf="oCitaAbreviada.area !== ''">
          <p>
            <i class="fas fa-user-tag" title="Área"></i>
            <span>{{ oCitaAbreviada.area }}</span>
          </p>

          <p *ngIf="oCitaAbreviada.fecha !== ''">
            <i class="far fa-calendar" title="Fecha"></i>
            <span>{{ oCitaAbreviada.fecha }}</span>
          </p>

          <p *ngIf="oCitaAbreviada.fecha !== ''">
            <i class="far fa-clock" title="hora"></i>
            <span>{{ oCitaAbreviada.hora }}</span>
          </p>

          <p *ngIf="oCitaAbreviada.tramite !== ''">
            <i class="far fa-file-alt" title="Trámite"></i>
            <span>{{ oCitaAbreviada.tramite }}</span>
          </p>
        </div>

        <span class="mensaje nota"
          >Dispone de 10 minutos para reservar la cita o el sistema la
          anulará</span
        >

        <form #frmSolicitante="ngForm" (ngSubmit)="onSubmitSolicitante()">
          <ng-template matStepLabel>Solicitante</ng-template>

          <label><b>Tipo identificador</b></label>
          <select
            name="cmbtiponifsol"
            #cmbtiponifsol
            (change)="changeTipoNIF('S', cmbtiponifsol.selectedIndex)"
          >
            <option selected>NIF</option>
            <option>CIF</option>
            <option>NIE</option>
            <option>Otros</option>
          </select>

          <label><b>Código identidad</b></label>
          <input
            name="dni"
            type="text"
            [(ngModel)]="oSolicitante.nif"
            maxlength="15"
            placeholder="* NIF, DNI, CIF, tarjeta residencia, nº pasaporte, ..."
            required
          />
          <span
            *ngIf="
              frmSolicitante.submitted &&
              (frmSolicitante.controls['dni'].errors || !ValidarCodigo('S'))
            "
            class="msgerror"
            >{{ sAvisoErrorNIFSol }}</span
          >

          <label><b>Nombre o Razón Social</b></label>
          <input
            name="nombre"
            type="text"
            maxlength="70"
            [(ngModel)]="oSolicitante.nombre"
            placeholder="* Nombre"
            required
          />
          <span
            *ngIf="
              frmSolicitante.submitted &&
              frmSolicitante.controls['nombre'].errors
            "
            class="msgerror"
            >Nombre obligatorio</span
          >

          <div class="flex-form">
            <div>
              <label *ngIf="cmbtiponifsol.selectedIndex != 1"
                ><b>Primer apellido</b></label
              >
              <input
                name="apellido1"
                type="text"
                maxlength="70"
                *ngIf="cmbtiponifsol.selectedIndex != 1"
                [(ngModel)]="oSolicitante.apellido1"
                placeholder="* Primer apellido"
                [required]="sTipoNIFsol !== 'C'"
              />
              <span
                *ngIf="frmSolicitante.submitted && Apellido1Requerido('S')"
                class="msgerror"
                >Primer apellido obligatorio</span
              >
            </div>
            <div>
              <label *ngIf="cmbtiponifsol.selectedIndex != 1"
                ><b>Segundo apellido</b></label
              >
              <input
                name="apellido2"
                type="text"
                maxlength="70"
                *ngIf="cmbtiponifsol.selectedIndex != 1"
                [(ngModel)]="oSolicitante.apellido2"
                placeholder="Segundo apellido"
              />
            </div>
          </div>

          <label><b>Email</b></label>
          <input
            name="email"
            type="email"
            [(ngModel)]="oSolicitante.email"
            maxlength="100"
            placeholder="* Email"
            required
          />
          <span
            *ngIf="
              frmSolicitante.submitted &&
              (frmSolicitante.controls['email'].errors || !ValidarEmail('S'))
            "
            class="msgerror"
            >Email obligatorio o no válido</span
          >

          <div class="flex-form">
            <div>
              <label><b>Teléfono móvil</b></label>
              <input
                id="tlfmovil"
                name="tlfmovil"
                type="text"
                onkeypress="return valideKey(event);"
                maxlength="9"
                oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                [(ngModel)]="oSolicitante.tlf1"
                placeholder="* Teléfono móvil"
                required
                pattern="[0-9]+"
              />
              <span
                *ngIf="
                  frmSolicitante.submitted &&
                  frmSolicitante.controls['tlfmovil'].errors
                "
                class="msgerror"
                >Tlf. móvil obligatorio</span
              >
            </div>
            <div>
              <label><b>Teléfono fijo</b></label>
              <input
                id="tlffijo"
                name="tlffijo"
                type="text"
                onkeypress="return valideKey(event);"
                maxlength="9"
                oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                [(ngModel)]="oSolicitante.tlf2"
                placeholder="Teléfono fijo"
                pattern="[0-9]+"
              />
            </div>
          </div>

          <label><b>Asunto</b></label>
          <textarea
            name="asunto"
            cols="50"
            rows="5"
            maxlength="400"
            [(ngModel)]="oSolicitante.asunto"
            placeholder="Motivo de su cita"
          ></textarea>

          <mat-slide-toggle
            color="primary"
            name="representante"
            [(ngModel)]="hayRepresentado"
            (change)="hayRepresentadoChanged(hayRepresentado)"
          >
            Actúa en representación de otra persona/empresa
          </mat-slide-toggle>

          <div class="filtrorepresentados" *ngIf="hayRepresentado">
            <select
              name="cmbRepresentados"
              #cmbRepresentados
              (change)="changeRepresentado(cmbRepresentados.selectedIndex)"
              [required]="hayRepresentado"
            >
              <option>Nuevo representado</option>
              <option>Buscar representado por código identidad</option>
            </select>

            <div *ngIf="iIndiceRepresentado === 1" class="buscar">
              <input
                name="dnirepresentado"
                type="text"
                maxlength="15"
                [disabled]="representadook"
                [(ngModel)]="sFiltroRepresentadoNIF"
                placeholder="* NIF, DNI, CIF, ..."
              />
              <i
                *ngIf="!representadook"
                (click)="BuscarRepresentado()"
                class="fas fa-search"
                title="Buscar"
              ></i>
              <i
                *ngIf="representadook"
                (click)="BorrarRepresentado()"
                class="fas fa-eraser"
                title="Borrar"
              ></i>
            </div>
            <div>
              <span *ngIf="sAvisoErrorNIFRepBusqueda !== ''" class="msgerror">{{
                sAvisoErrorNIFRepBusqueda
              }}</span>
            </div>
          </div>

          <br /><br />
          <div class="btn-grupo">
            <!-- <button class="btn" mat-button matStepperPrevious>Retroceder</button> -->
            <button type="submit" class="btn-general">
              <span>Continuar</span>
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step
        *ngIf="hayRepresentado && iIndiceRepresentado === 0"
        [stepControl]="frmRepresentado"
      >
        <ng-template matStepLabel>Representado</ng-template>
        <form #frmRepresentado="ngForm" (ngSubmit)="onSubmitRepresentado()">
          <label><b>Tipo identificador</b></label>
          <select
            name="cmbtiponifrep"
            #cmbtiponifrep
            (change)="changeTipoNIF('R', cmbtiponifrep.selectedIndex)"
          >
            <option selected>NIF</option>
            <option>CIF</option>
            <option>NIE</option>
            <option>Otros</option>
          </select>

          <label><b>Código identidad</b></label>
          <input
            name="dnirep"
            type="text"
            maxlength="15"
            [(ngModel)]="oRepresentado.nif"
            placeholder="* NIF, DNI, CIF, tarjeta residencia, nº pasaporte, ..."
            required
          />
          <span
            *ngIf="
              frmRepresentado.submitted &&
              (frmRepresentado.controls['dnirep'].errors || !ValidarCodigo('R'))
            "
            class="msgerror"
            >{{ sAvisoErrorNIFRep }}</span
          >
          <span 
          *ngIf="frmRepresentado.submitted && sErrorNifIguales"
          class="msgerror">
            {{ sErrorNifIguales }}
          </span>

          <label><b>Nombre o Razón Social</b></label>
          <input
            name="nombrerep"
            type="text"
            maxlength="70"
            [(ngModel)]="oRepresentado.nombre"
            placeholder="* Nombre"
            required
          />
          <span
            *ngIf="
              frmRepresentado.submitted &&
              frmRepresentado.controls['nombrerep'].errors
            "
            class="msgerror"
            >Nombre obligatorio</span
          >

          <div class="capa50" *ngIf="cmbtiponifrep.selectedIndex != 1">
            <label><b>Primer apellido</b></label>
            <input
              name="apellido1rep"
              type="text"
              maxlength="70"
              [(ngModel)]="oRepresentado.apellido1"
              placeholder="* Primer apellido"
              [required]="sTipoNIFrep !== 'C'"
            />
            <span
              *ngIf="frmRepresentado.submitted && Apellido1Requerido('R')"
              class="msgerror"
              >Primer apellido obligatorio</span
            >
          </div>
          <div class="capa50" *ngIf="cmbtiponifrep.selectedIndex != 1">
            <label><b>Segundo apellido</b></label>
            <input
              name="apellido2rep"
              type="text"
              maxlength="70"
              [(ngModel)]="oRepresentado.apellido2"
              placeholder="Segundo apellido"
            />
          </div>
          <div class="clearfloat"></div>

          <label><b>Email</b></label>
          <input
            name="emailrep"
            type="email"
            maxlength="100"
            [(ngModel)]="oRepresentado.email"
            placeholder="* Email"
            required
          />
          <span
            *ngIf="
              frmRepresentado.submitted &&
              (frmRepresentado.controls['emailrep'].errors ||
                !ValidarEmail('R'))
            "
            class="msgerror"
            >Email obligatorio o no válido</span
          >

          <div class="capa50">
            <label><b>Teléfono móvil</b></label>
            <input
              name="tlfmovilrep"
              type="text"
              onkeypress="return valideKey(event);"
              maxlength="9"
              oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              [(ngModel)]="oRepresentado.tlf1"
              placeholder="* Teléfono móvil"
              required
              pattern="[0-9]+"
            />
            <span
              *ngIf="
                frmRepresentado.submitted &&
                frmRepresentado.controls['tlfmovilrep'].errors
              "
              class="msgerror"
              >Tlf. móvil obligatorio</span
            >
          </div>
          <div class="capa50">
            <label><b>Teléfono fijo</b></label>
            <input
              name="tlffijorep"
              type="text"
              onkeypress="return valideKey(event);"
              maxlength="9"
              oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              [(ngModel)]="oRepresentado.tlf2"
              placeholder="Teléfono fijo"
              pattern="[0-9]+"
            />
          </div>
          <div class="clearfloat"></div>

          <div class="btn-grupo">
            <button class="btn cancelar" matStepperPrevious>Retroceder</button>
            <button type="submit" class="btn-general">
              <span>Continuar</span>
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Confirmación</ng-template>
        <div *ngIf="CargarResumenCita()" class="resumen-cita">
          <h1>Resumen de la Cita</h1>

          <p>
            <i class="fas fa-user-tag" title="Área"></i>
            <span>{{ oCitaAbreviada.area }}</span>
          </p>

          <p>
            <i class="far fa-calendar" title="Fecha"></i>
            <span>{{ oCitaAbreviada.fecha }}</span>
          </p>

          <p>
            <i class="far fa-clock" title="Hora"></i>
            <span>{{ oCitaAbreviada.hora }}</span>
          </p>

          <p>
            <i class="far fa-file-alt" title="Trámite"></i>
            <span>{{ oCitaAbreviada.tramite }}</span>
          </p>

          <div class="mensaje">
            <p
              *ngIf="oTramiteActivo != null"
              [innerHTML]="oTramiteActivo.INFO_TRAMITE"
            ></p>
            <p>Documentación que debe aportar:</p>
            <ul>
              <li *ngFor="let sDoc of oDetalleCita.DOCUMENTACION">
                {{ sDoc }}
              </li>
            </ul>
          </div>

          <p class="titulo-info-adicional">Información del solicitante:</p>

          <table>
            <tr>
              <td>Código Identidad:</td>
              <td>{{ oDetalleCita.SOLICITANTE_NIF }}</td>
            </tr>
            <tr>
              <td>Solicitante:</td>
              <td>{{ oDetalleCita.SOLICITANTE }}</td>
            </tr>
            <tr>
              <td>Teléfono Móvil:</td>
              <td>{{ oDetalleCita.SOLICITANTE_TLF1 }}</td>
            </tr>
            <tr
              *ngIf="
                oDetalleCita.SOLICITANTE_TLF2 != null &&
                oDetalleCita.SOLICITANTE_TLF2 != undefined &&
                oDetalleCita.SOLICITANTE_TLF2 !== ''
              "
            >
              <td>Teléfono Fijo:</td>
              <td>{{ oDetalleCita.SOLICITANTE_TLF2 }}</td>
            </tr>
            <tr>
              <td>Email:</td>
              <td>{{ oDetalleCita.SOLICITANTE_EMAIL }}</td>
            </tr>
            <tr
              *ngIf="
                oDetalleCita.MOTIVO_CITA != null &&
                oDetalleCita.MOTIVO_CITA != undefined &&
                oDetalleCita.MOTIVO_CITA !== ''
              "
            >
              <td>Motivo cita:</td>
              <td>{{ oDetalleCita.MOTIVO_CITA }}</td>
            </tr>
            <tr
              *ngIf="
                oDetalleCita.REPRESENTADO_NIF != null &&
                oDetalleCita.REPRESENTADO_NIF != undefined &&
                oDetalleCita.REPRESENTADO_NIF !== ''
              "
            >
              <td></td>
              <td>
                * Actúa en representación de {{ sEnRepresentacionDe }} con
                código identidad {{ oDetalleCita.REPRESENTADO_NIF }}
              </td>
            </tr>
          </table>

          <mat-slide-toggle
            color="primary"
            name="chkaceptalosterminos"
            (change)="changeAceptaLosTerminos()"
          >
            Debe aceptar los
            <a class="link-deco" (click)="AbrirEnlace(1)"
              >Términos y Condiciones</a
            >.
          </mat-slide-toggle>
          <p>
            Para más información consulte nuestra
            <a class="link-deco" (click)="AbrirEnlace(2)"
              >Política de Privacidad</a
            >.
          </p>
        </div>
        <div class="btn-grupo">
          <button class="btn cancelar" matStepperPrevious>Retroceder</button>
          <button
            class="btn-general"
            *ngIf="AceptaLosTerminos"
            (click)="ConfirmarCita()"
            [disabled]="isConfirming"
          >
            <span>Confirmar</span>
          </button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
    <!-- </mat-horizontal-stepper> -->
    <br />
    <button
      *ngIf="!CitaConfirmada"
      class="btn cancelar center"
      (click)="CancelarCita()"
    >
      Cancelar Cita
    </button>
  </div>
</ng-template>
